import ShapeZeroImage from "_assets/images/landing/shape-0.avif";
import ShapeOneImage from "_assets/images/landing/shape-1.avif";
import ShapeTwoImage from "_assets/images/landing/shape-2.avif";
import ShapeThreeImage from "_assets/images/landing/shape-3.avif";
import ShapeFourImage from "_assets/images/landing/shape-4.avif";
import ShapeFiveImage from "_assets/images/landing/shape-5.avif";
import ShapeSixImage from "_assets/images/landing/shape-6.avif";
import ShapeSevenImage from "_assets/images/landing/shape-7.avif";
import ShapeEightImage from "_assets/images/landing/shape-8.avif";
import ShapeNineImage from "_assets/images/landing/shape-9.avif";
import ShapeTenImage from "_assets/images/landing/shape-10.avif";

export const landingPageImages = [
  { image: ShapeZeroImage, span: 8 },
  { image: ShapeOneImage, span: 8 },
  { image: ShapeTwoImage, span: 8 },
  { image: ShapeThreeImage, span: 8 },
  { image: ShapeFourImage, span: 8 },
  { image: ShapeFiveImage, span: 8 },
  { image: ShapeSixImage, span: 8 },
  { image: ShapeSevenImage, span: 16 },
  { image: ShapeEightImage, span: 8 },
  { image: ShapeNineImage, span: 8 },
  { image: ShapeTenImage, span: 8 },
];
